import React, { useContext, useState } from 'react'
import { CustomSelectComplex } from '../CustomSelectComplex/CustomSelectComplex'
import { t } from 'i18next'
import { ButtonBlueNoBorder } from '../Buttons/ButtonBlueNoBorder'
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn'
import { ButtonBlue } from '../Buttons/ButtonBlue'
import AccessEquipmentContext from '../../context/AccessEquipment/AccessEquipmentContext'
import { useEffect } from 'react'
import { EquipmetsOrTool } from '../EquipmetsOrTool/EquipmetsOrTool'
import useWindowSize from '../../customHooks/useWindowSize'
import AccessContext from '../../context/AccessContext/AccessContext'
import { getTenantInfoByKey, getUserBuilding } from '../../helpers/helpers'
import { FormCheckModal } from './FormCheckModal'

const CreateEquipment = () => {

  const { windowWidth } = useWindowSize()

  const { setStep, accessState } = useContext(AccessContext);
  const { accessWithCar, type } = accessState;

  const { accessEquipmentState, getAccessEquipments, setAccessEquipmentsSelected, cleanAccessEquipmentState } = useContext(AccessEquipmentContext);

  const { equipments = [], accessEquipmentsSelected = [], accessEquipment = {} } = accessEquipmentState;

  const equipmentsOptions = equipments.map(equipment => ({
    label: equipment.equipmentDescription,
    value: equipment.equipmentTypeId
  }))

  const [formState, setFormState] = useState(accessEquipment);
  const { id = null, details = '' } = formState;

  const [equipmentsCreated, setEquipmentsCreated] = useState(accessEquipmentsSelected)

  const [checkFormModal, setCheckFormModal] = useState({
    showModal: false,
    setShowModal: () => setCheckFormModal({ ...checkFormModal, setShowModal: false }),
    reason: '',
    cuestion: '',
    actionText: '',
    onClickAction: null
  })

  const { showModal, setShowModal } = checkFormModal

  const disabled = id === null || details.trim().length === 0;

  const handleChange = (name, value) => {
    setFormState({
      ...formState,
      [name]: value
    })
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (disabled) return

    setEquipmentsCreated([
      ...equipmentsCreated,
      formState
    ])

    setFormState({
      id: null,
      details: ''
    })
  }

  const onDelete = (details) => {
    setEquipmentsCreated(equipmentsCreated.filter(equipmentCreated => equipmentCreated.details !== details));
  }

  const onEdit = (details) => {
    const equipmentCreatedToEdit = equipmentsCreated.find(equipmentCreated => equipmentCreated.details === details);
    setFormState(equipmentCreatedToEdit);
    onDelete(details);
  }

  const handleNextStep = (equipmentsCreated) => {
    setAccessEquipmentsSelected(equipmentsCreated);

    setFormState({
      id: null,
      details: ''
    });

    const haveAccessBuildings = getUserBuilding().buildingDescription !== t('NO_BUILDING');;

    const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit');

    if (haveAccessBuildings) {
      setStep('SELECT_AREA')
      return
    }

    if (havePersonsToVisit) {
      setStep('SELECT_PERSON_TO_VISIT')
      return
    }

    setStep('DETAIL')
    return
  };

  const handleReturnStep = () => {
    const isVisit = type === 'ACCESS_VISIT';
    const prevStep = accessWithCar ? (isVisit ? 'VISIT_VEHICLE_FORM' : 'VEHICLES_SELECTABLE') : 'ACCESS_WITH';
    setStep(prevStep)
    cleanAccessEquipmentState();
  }

  const handleCheckForm = () => {
    if (disabled === false) {
      setCheckFormModal({
        ...checkFormModal,
        showModal: true,
        reason: t('EQUIPMENT_DATA_NO_CONFIRM'),
        cuestion: t('DO_YOU_WANT_TO_ADD'),
        actionText: t('ADD'),
        onClickAction: () => {
          handleNextStep([
            ...equipmentsCreated,
            formState
          ]);
        },
      })
      return
    }
    if (id !== null || details.trim().length > 0) {
      setCheckFormModal({
        ...checkFormModal,
        showModal: true,
        reason: t('EQUIPMENT_DATA_NO_COMPLETED'),
        cuestion: t('DO_YOU_WANT_TO_COMPLETE'),
        actionText: t('COMPLETE'),
        onClickAction: setShowModal,
      })
      return
    }
    handleNextStep(equipmentsCreated);
  }

  useEffect(() => {
    getAccessEquipments();
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {showModal && (
        <FormCheckModal
          {...checkFormModal}
          onClickContinue={() => handleNextStep(equipmentsCreated)}
        />
      )}
      <div className='d-flex flex-column justify-content-between h-100'>
        <div>
          {equipmentsCreated.length > 0 && (
            <div
              className='d-flex flex-column gap-2 no-show-scroll mb-4'
              style={{
                maxHeight: windowWidth < 567 ? '120px' : '270px',
                overflowX: 'auto'
              }}
            >
              {equipmentsCreated.map(equipmentCreated =>
                <EquipmetsOrTool
                  key={equipmentCreated.details}
                  type={equipmentCreated.id.label}
                  details={equipmentCreated.details}
                  deleteFn={() => onDelete(equipmentCreated.details)}
                  editFn={() => onEdit(equipmentCreated.details)}
                />
              )}
            </div>
          )}
          <form
            className='d-flex flex-column justify-content-between gap-4'
            onSubmit={onSubmit}
          >
            <div className='d-flex flex-column gap-4'>
              <div>
                <label
                  htmlFor="plate_number"
                  className='form-label blue-dark-text'
                >
                  {t('EQUIPMENT_OR_TOOLS_SELECTABLE')}
                </label>
                <CustomSelectComplex
                  placeholder={t('SELECT')}
                  options={equipmentsOptions}
                  value={id}
                  onChange={(option) => handleChange('id', option)}
                  isClearable
                />
              </div>

              <div>
                <label
                  htmlFor="details"
                  className='form-label blue-dark-text'
                >
                  {t('ADDITIONAL_INFO')}
                </label>
                <textarea
                  className='form-control'
                  name="details"
                  cols="30"
                  rows="6"
                  placeholder={t('ADD_INFO_OF_TOOL_OR_EQUIPMENT')}
                  value={details}
                  onChange={(e) => handleChange('details', e.target.value)}
                >
                </textarea>
              </div>

              <div className='ms-auto'>
                <ButtonBlueNoBorder
                  type='submit'
                  disabled={disabled}
                  className='border-0'
                >
                  {t('ADD')}
                </ButtonBlueNoBorder>
              </div>
            </div>
          </form>
        </div>
        <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
          <div className="w-75">
            <ButtonBlackReturn
              title={t('GET_BACK')}
              onClick={handleReturnStep}
            />
          </div>
          <div className="w-50">
            <ButtonBlue
              className='w-100'
              onClick={() => handleCheckForm(equipmentsCreated)}
            >
              {t('NEXT')}
            </ButtonBlue>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateEquipment